import React from "react";
import { useState } from "react";
import { useContext } from "react";
//import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form"
import Select from 'react-select'

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import { GetTemplateType, TemplateForm } from "./TemplateForm";


export default function TemplateCreate({}) {

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  //const media_url = useContext(MEDIA_URL);
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();

  //let { templateId } = useParams();
  //templateId = Number(templateId);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {},
  });

  
  const onSubmit = (data) => {
    console.log(data);


    //let typeValue = data.type.value;
    //data.type = typeValue;
    data.type = "CONTRACT"

    // refactor this. Use OnChange function for Select
    let groupIds = data.group.map(x => (x.value));
    data.group = groupIds;

    axios_api.post(api_url + `/manage_template/`, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("Template created");
        navigate("/templates");
        //navigate(0);
      },
      (error) => {
        console.log(error);
        //navigate("/shopping_cart");
      }
    );
  }


  React.useEffect(() => {

    let groups = axios_api.get(api_url + '/groups/', {
      headers: {"Authorization": token},
    });

    groups.then(
      (result) => {
        let apiReturnedGroups = result.data;
        setGroups(apiReturnedGroups);
      },
      (error) => {
        console.log(error);
        setGroups([]);
      }
    );
  }, []);


  let groupOptions = [];
  for (let i in groups) {
    groupOptions.push(
      { value: groups[i].id, label: groups[i].name }
    );
  }
 
  return (
    <>
      <h3 className="m-3">Создать шаблон договора</h3> 
      <TemplateForm
        groups={groups}
        control={control}
        register={register}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
      />
    </>
  )
}